import { render, staticRenderFns } from "./PlatformTermsModal.vue?vue&type=template&id=2fad2a97&scoped=true"
import script from "./PlatformTermsModal.vue?vue&type=script&lang=js"
export * from "./PlatformTermsModal.vue?vue&type=script&lang=js"
import style0 from "./PlatformTermsModal.vue?vue&type=style&index=0&id=2fad2a97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fad2a97",
  null
  
)

export default component.exports